import React from "react";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../UserAvatar/UserAvatar";
import { usePageMetadata } from "../../../context/PageMetadataContext";
import "./MobileTopNavbar.css";
import rNameLogo from "../../../assets/Reppi.svg";

function MobileTopNavbar() {
  const navigate = useNavigate();
  const { pageTitle } = usePageMetadata();

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <nav className="mobile-top-navbar">
      <div className="mobile-top-navbar-content">
        {/* Left side - Reppi name logo or page title */}
        <div className="mobile-top-navbar-left">
          {pageTitle ? (
            <div className="mobile-top-navbar-page-title">{pageTitle}</div>
          ) : (
            <button
              className="mobile-top-navbar-logo-button"
              onClick={handleLogoClick}
              aria-label="Go to dashboard"
            >
              <img
                src={rNameLogo}
                alt="Reppi"
                className="mobile-top-navbar-logo"
              />
            </button>
          )}
        </div>

        {/* Right side - User avatar */}
        <div className="mobile-top-navbar-right">
          <UserAvatar size="small" showName={false} />
        </div>
      </div>
    </nav>
  );
}

export default MobileTopNavbar;
